// extracted by mini-css-extract-plugin
var _1 = "DvavLy";
var _2 = "yET6tl";
var _3 = "wpULRN";
var _4 = "Nq_Lhn";
var _5 = "z8ioCv";
var _6 = "WxEzaK";
var _7 = "iE1hBH";
var _8 = "ec43JO";
var _9 = "NuA0F6";
var _a = "khuHp_";
export { _1 as "carousel", _2 as "ease-transition", _3 as "fullScreen", _4 as "gradient-titanic-80", _5 as "linear-transition-05", _6 as "shadow-medium-titanic", _7 as "shadow-medium-titanic-hover", _8 as "shadow-titanic-1", _9 as "shadow-white", _a as "text" }
